import React, { ChangeEvent, useEffect } from "react";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import IUnit_Of_Measurement_Set from "../../../models/IUnit_Of_Measurement_Set";

type Props = {
    item: ICatalog_Item;
    selectedOption: (option: IUnit_Of_Measurement_Set) => void;
    currentOption?: IUnit_Of_Measurement_Set;
};

export const UomSetSelectOption = (props: Props) => {
    let options: { title: string; value: number; detail: IUnit_Of_Measurement_Set }[] = [];

    if (props.item?.Base_Unit) {
        if (!props.item.Base_Unit.is_hidden) {
            options.push({
                title: props.item.Base_Unit.unit_name,
                value: props.item.Base_Unit.id,
                detail: props.item?.Base_Unit,
            });
        }

        if (props.item?.Base_Unit?.Related_Units) {
            options = options.concat(
                props.item.Base_Unit.Related_Units.filter((relatedUnit) => !relatedUnit.is_hidden).map((unit) => {
                    return {
                        title: unit.unit_name,
                        value: unit.id,
                        detail: unit,
                    };
                })
            );
        }
    }

    const getInitialSelectedOption = () => {
        if (props.currentOption) {
            return {
                title: props.currentOption.unit_name,
                value: props.currentOption.id,
                detail: props.currentOption,
            };
        } else if (props.item?.Base_Unit) {
            return {
                title: props.item.Base_Unit.unit_name,
                value: props.item.Base_Unit.id,
                detail: props.item.Base_Unit,
            };
        }

        return null;
    };

    const [selectedOption, setSelectedOption] = React.useState<{ title: string; value: number; detail: IUnit_Of_Measurement_Set } | null>(
        getInitialSelectedOption()
    );

    // If we don't do this, then the selected option will not propogate to the item when we go to save it
    // if the user makes no changes.
    useEffect(() => {
        if (selectedOption?.detail) {
            props.selectedOption(selectedOption.detail);
        }
    }, [selectedOption]);

    const handleChange = (e: ChangeEvent<any>) => {
        e.stopPropagation();
        e.preventDefault();

        const { name, value } = e.target;

        for (const option of options) {
            if (option.value === Number(value)) {
                setSelectedOption(option);
                // props.selectedOption(option.detail);
            }
        }
    };

    return (
        <div className={"UomSetSelectOption"}>
            <OwSelectOption
                fn={handleChange}
                titleProp={"title"}
                valueProp={"value"}
                name={"uom_set"}
                options={options}
                selectedOption={selectedOption}
                selectedOptionProp={"value"}
                sizeClass={" "}
            />
        </div>
    );
};
